import React from "react";

// Wraps admin pages so a render-time error (a bad API shape, a null where
// an object was expected, etc.) shows a recoverable message instead of a
// blank white screen. This does NOT replace fixing bugs at the source -
// it's a last-resort safety net for whatever we haven't caught yet.
export default class AdminErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("Admin page crashed:", error, info?.componentStack);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={styles.wrap}>
          <div style={styles.card}>
            <h2 style={styles.title}>Something went wrong</h2>
            <p style={styles.text}>
              This admin page hit an unexpected error and stopped rendering. Your data
              wasn't affected. Reloading usually fixes it.
            </p>
            {this.state.error?.message && (
              <p style={styles.errMsg}>{this.state.error.message}</p>
            )}
            <button style={styles.button} onClick={this.handleReload}>
              Reload page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

const styles = {
  wrap: { display: "flex", justifyContent: "center", alignItems: "center", minHeight: "60vh", padding: "20px" },
  card: { background: "#fff", border: "1px solid #eee", borderRadius: "12px", padding: "30px", maxWidth: "440px", textAlign: "center", boxShadow: "0 2px 10px rgba(0,0,0,0.08)" },
  title: { margin: "0 0 10px 0", color: "#c0392b" },
  text: { color: "#555", fontSize: "14px", lineHeight: 1.5 },
  errMsg: { color: "#999", fontSize: "12px", fontFamily: "monospace", wordBreak: "break-word" },
  button: { marginTop: "16px", padding: "10px 24px", background: "#2874f0", color: "#fff", border: "none", borderRadius: "8px", fontWeight: "bold", cursor: "pointer" },
};